/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {recipientSelectorSearch} from '../api'

 export const useQueryRecipientSelectorSearch = createReactQueryHook('recipientSelectorSearch', recipientSelectorSearch)
